// Libraries
import { Flex, Text } from '@chakra-ui/react';
// Types
import { Sizes } from '@globalTypes/index';
import { RatingWidgetItemProps } from './RatingWidgetItem.types';
// Components
import { RatingLabeled } from '@molecules/index';

/**
 * A component representing a single item in a rating widget.
 * @component
 *
 * @param {RatingWidgetItemProps} props - The props for the RatingWidgetItem component.
 * @param {RatingCategory} props.rating - The rating category for the item.
 * @param {number} props.score - The score value for the item.
 * @param {string} props.label - The label or title for the item.
 * @returns {ReactElement} The element representing the rating widget item.
 */
export const RatingWidgetItem = ({ rating, score, label }: RatingWidgetItemProps) => (
  <Flex
    columnGap={{ base: 1, md: 3 }}
    direction={{ base: 'column-reverse', md: 'row' }}
    alignItems={{ base: 'flex-start', md: 'center' }}
  >
    <Text variant='faded' fontWeight='semibold' fontSize='xs' mt={{ base: 1, md: 0 }}>
      {label}
    </Text>
    <RatingLabeled rating={rating} score={score} size={Sizes.md} />
  </Flex>
);
